(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', './FormContext', './utilities'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('./FormContext'), require('./utilities'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.FormContext, global.utilities);
    global.Validation = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _FormContext, _utilities) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var propTypes = {
    children: _propTypes.func.isRequired,
    config: (0, _propTypes.shape)({}).isRequired,
    initialValues: (0, _propTypes.shape)({}),
    transforms: (0, _propTypes.shape)({})
  };

  var Validation = function (_Component) {
    _inherits(Validation, _Component);

    function Validation() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Validation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Validation.__proto__ || Object.getPrototypeOf(Validation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isRegistered: false
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Validation, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _props = this.props,
            config = _props.config,
            initialValues = _props.initialValues,
            register = _props.register,
            transforms = _props.transforms;
        register(config, transforms, Object.keys(config).reduce(function (allFields, field) {
          var value = (0, _utilities.getFirstDefinedValue)(initialValues[field], '');

          if (typeof transforms[field] === 'function') {
            value = transforms[field](value);
          }

          return _extends({}, allFields, _defineProperty({}, field, value));
        }, {}));
        this.setState({
          isRegistered: true
        });
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.props.unregister(this.props.config);
        this.setState({
          isRegistered: false
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props2 = this.props,
            children = _props2.children,
            dirty = _props2.dirty,
            errors = _props2.errors,
            fields = _props2.fields,
            isValid = _props2.isValid,
            resetAll = _props2.resetAll,
            setError = _props2.setError,
            setField = _props2.setField,
            submit = _props2.submit,
            submitted = _props2.submitted;
        var validationContext = {
          dirty: dirty,
          errors: errors,
          fields: fields,
          isValid: isValid,
          resetAll: resetAll,
          setError: setError,
          setField: setField,
          submit: submit,
          submitted: submitted
        };
        return this.state.isRegistered ? children(validationContext) : null;
      }
    }]);

    return Validation;
  }(_react.Component);

  Validation.defaultProps = {
    errors: {},
    fields: {},
    initialValues: {},
    transforms: {}
  };
  Validation.propTypes = _extends({}, propTypes, {
    // FormContext
    dirty: (0, _propTypes.shape)({}).isRequired,
    errors: (0, _propTypes.shape)({}).isRequired,
    fields: (0, _propTypes.shape)({}).isRequired,
    isValid: _propTypes.bool.isRequired,
    register: _propTypes.func.isRequired,
    resetAll: _propTypes.func.isRequired,
    setError: _propTypes.func.isRequired,
    setField: _propTypes.func.isRequired,
    submit: _propTypes.func.isRequired,
    submitted: _propTypes.bool.isRequired,
    unregister: _propTypes.func.isRequired
  });
  var ValidationWithFormContext = (0, _FormContext.withFormContext)(Validation);
  ValidationWithFormContext.propTypes = propTypes;
  exports.default = ValidationWithFormContext;
});